import React from 'react';
// import { Link } from 'react-router-dom';
import vicFalls1 from 'assets/img/stock/vfalls/vfalls_1.jpg'
import garden from 'assets/img/stock/capetown/garden.jpg'


export default () => // <!-- Contacts -->
(
    <section className="boxes" id="contacts">
        <div className="container-fluid">

            {/*<!-- Title -->*/}
            <h4 className="sml_abs_title wow fadeInUp">Get in touch</h4>

            <div className="row">

                {/*<!-- Contacts -->*/}
                <div
                    className="col-md-6 bordered_block image_bck bordered_wht_border white_txt"
                    data-image={garden}
                >
                    <div
                        className="over"
                        data-opacity="0.6"
                        data-color="#292929"
                    />
                    <div className="col-md-12 simple_block text-left">
                        <h3>Contacts</h3>
                        <span className="contacts_ti ti-mobile" />
                        +1 434 962 6562
                        <br />
                        <span className="contacts_ti ti-email" />
                        <a href="mailto:bookings@southafricadreamtours.com">
                            bookings@southafricadreamtours.com
                        </a>
                    </div>
                </div>

                {/*<!-- Write Us -->*/}
                <div
                    className="col-md-6 bordered_block image_bck bordered_wht_border white_txt"
                    data-image={vicFalls1}
                >
                    <div
                        className="over"
                        data-opacity="0.6"
                        data-color="#292929"
                    />
                    <div className="col-md-12 simple_block text-left">
                        <h3>Write Us</h3>
                        <form
                            action="mailto:bookings@southafricadreamtours.com"
                            method="POST"
                        >
                            <div className="row">
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control form-opacity"
                                        placeholder="Name*"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        name="surname"
                                        className="form-control form-opacity"
                                        placeholder="Surname*"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        name="city"
                                        className="form-control form-opacity"
                                        placeholder="City"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        name="email"
                                        className="form-control form-opacity"
                                        placeholder="E-mail*"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        name="phone"
                                        className="form-control form-opacity"
                                        placeholder="Phone"
                                    />
                                </div>
                                <div className="col-md-12">
                                    <textarea
                                        placeholder="Message"
                                        name="message"
                                        className="form-control form-opacity"
                                    />
                                </div>
                                <div className="col-md-12">
                                    <input
                                        type="submit"
                                        className="btn btn-white submit"
                                        value="Send"
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                {/*<!-- Write Us End -->*/}

            </div>
            {/*<!-- Row End -->*/}
        </div>
    </section>
);



// WEBPACK FOOTER //
// ./src/components/contacts/Contacts.jsx